import { styled } from '@mui/material/styles';

export const UserNameWithStatusRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  minWidth: 0,
});

export const UserName = styled('div')(({ theme }) => ({
  // Was the SCSS `$primary-dark` (#003E47) — the same role on the migrated Figma
  // palette is the darkest brand step, custom.brand[128].
  color: theme.palette.custom.brand[128],
  fontWeight: 700,
  fontSize: '0.875rem',
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
